module.exports = __webpack_public_path__ + "img/department.9b544ab4.png";